<template>
  <view class="tw-empty">
    <image class="image" :src="src" />
    <view class="label-big" v-if="msg1">{{ msg1 }}</view>
    <view class="label-small" v-if="msg2">{{ msg2 }}</view>
    <slot></slot>
  </view>
</template>

<script>
export default {
  props: {
    // 无数据的展示图
    src: {
      type: String,
      default: 'https://image.ceekee.com/error/icon_nodata.png', //空数据
      // default: 'https://image.ceekee.com/error/icon_nosearch.png',  //空搜索
    },
    // 提示1-大字号
    msg1: {
      type: String,
      default: '',
    },
    // 提示2-小字号
    msg2: {
      type: String,
      default: '',
    },
  },
  name: 'TwEmpty',
};
</script>

<style scoped lang="less" scoped>
.tw-empty {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .image {
    height: 250rpx;
    width: 250rpx;
  }
  .label-big {
    margin-top: 20rpx;
    color: #141414;
    font-size: 32rpx;
    font-weight: 500;
    line-height: 40rpx;
    text-align: center;
  }
  .label-small {
    margin-top: 20rpx;
    color: #8c8c8c;
    font-size: 24rpx;
    font-weight: 500;
    line-height: 32rpx;
    text-align: center;
  }
}
</style>
